// Shared navbar utilities and constants

/**
 * Handle removing focus after interaction - more robust approach
 * Used across all navbar components to ensure proper focus management
 */
export const handleBlurOnClick = (e) => {
    // Immediate blur
    e.target.blur();
    // Delayed blur to ensure it works with React Router
    setTimeout(() => {
        if (document.activeElement) {
            document.activeElement.blur();
        }
    }, 100);
};

/**
 * Standard link styling for navbar links
 * Consistent across all navbar components
 */
export const linkStyle =
    "relative px-4 py-2 rounded-lg font-medium text-base-content hover:text-primary hover:bg-gradient-to-r hover:from-primary/10 hover:to-primary/5 active:bg-gradient-to-r active:from-primary/15 active:to-primary/8 active:text-primary transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 focus:ring-offset-base-100 active:scale-95 group";

/**
 * Standard navbar container styling
 */
export const navbarContainerStyle =
    "navbar bg-gradient-to-r from-base-300 to-base-200 border-b border-primary/20 backdrop-blur-sm fixed top-0 left-0 right-0 z-48 shadow-lg";
